import { all, fork, takeEvery } from 'redux-saga/effects';
import { loadEntities, updateEntity } from 'helpers/utilHelpers';
import { CALCULATE_USER_SALARY, LOAD_USER_SALARY_HISTORY, UPDATE_SALARY_HISTORY } from 'constants/ActionTypes';

function* loadSalaryHistory() {
  yield takeEvery(LOAD_USER_SALARY_HISTORY, loadEntities);
}

function* calculateUserSalary() {
  yield takeEvery(CALCULATE_USER_SALARY, updateEntity);
}

function* updateSalaryHistory() {
  yield takeEvery(UPDATE_SALARY_HISTORY, updateEntity);
}

export default function* rootSaga() {
  yield all([fork(loadSalaryHistory), fork(calculateUserSalary), fork(updateSalaryHistory)]);
}
